export default __webpack_public_path__ + "assets/front/scss/formulaire.7269bcfba226778c6cec2860ba2cf6f0.css";